import { defineTranslateKeys } from 'lib/tolgee'

export default defineTranslateKeys({
  trendingCompareErrorMessage: {
    key: 'SelectedItemsBar-trendingCompareErrorMessage',
    defaultValue: 'A comparação de tópicos de tendência estará disponível em breve',
  },
  nicheEditLimit: {
    key: 'SelectedItemsBar-nicheEditLimit',
    defaultValue: 'Não é possível agrupar mais de 5 nichos simultaneamente.',
  },
  editNiche: {
    key: 'SelectedItemsBar-editNiche',
    defaultValue: 'Editar nichos',
  },
})
